import * as actions from 'actions/ScheduleFilter';

const INITIAL_STATE = {
	groups: [],
	selectedUsers: [],
	selectedGroups: [],
	//////////////////// OLD BELOW /////////////////////////
	allFilter: false,
	activitiesFilter: {},
	userFilter: [],
	displayMySchedule: true,
	customGroup: [],
	storedSearch: [],
	advancedCalendarActive: false,
};

const isGroupActive = (group, id) => {
	if (Object.keys(group).length === 0) {
		return true;
	}

	return group[id];
}

const getUniqueStudents = (userFilter) => {
	let selectedStudents = [];
	Object.values(userFilter).forEach(group => {
		Object.values(group.students).forEach(student => {
			if (!selectedStudents.some(s => s === student.id)) {
				selectedStudents.push(student.id);
			}
		});
	});
	return selectedStudents.length;
}
const getUniqueOwners = (userFilter) => {
	let selectedOwners = [];
	Object.values(userFilter).forEach(group => {
		Object.values(group.owners).forEach(owner => {
			if (!selectedOwners.some(o => o === owner.id)) {
				selectedOwners.push(owner.id);
			}
		});
	});
	return selectedOwners.length;
}

const selectedUsersChanged = (previousSelectedUsers, newSelectedUsers) => {
	if (previousSelectedUsers.length !== newSelectedUsers.length) {
		return true;
	}

	const oldIds = previousSelectedUsers.map(u => u.userId).sort();
	const newIds = newSelectedUsers.map(u => u.userId).sort();

	for (let i = 0; i < oldIds.length; i++) {
		if (oldIds[i] !== newIds[i]) {
			return true;
		}
	}
	return false;
}
const selectedGroupsChanged = (previousSelectedGroups, newSelectedGroups) => {
	if (previousSelectedGroups.length !== newSelectedGroups.length) {
		return true;
	}

	const oldIds = previousSelectedGroups.map(u => u.id).sort();
	const newIds = newSelectedGroups.map(u => u.id).sort();

	for (let i = 0; i < oldIds.length; i++) {
		if (oldIds[i] !== newIds[i]) {
			return true;
		}
	}
	return false;
}

export default function (state = INITIAL_STATE, action) {
	let newUserFilter = null;
	switch (action.type) {
		case actions.UPDATE_FILTER:
			if (action.payload.allData) {
				return { ...state, activitiesFilter: action.payload.obj, allFilter: true };
			}

			return {
				...state,
				activitiesFilter: {
					...state.activitiesFilter,
					...action.payload.obj,
				},
				allFilter: false,
			};

		case actions.TOGGLE_ADVANCED_CALENDAR:
			return { ...state, advancedCalendarActive: !state.advancedCalendarActive };

		case actions.CLEAR_FILTER:
			return {
				...state,
				activitiesFilter: action.payload.filterData,
				allFilter: false,
			};

		case actions.TOGGLE_MY_SCHEDULE:
			return {
				...state,
				displayMySchedule: !state.displayMySchedule,
			};

		case actions.SET_CUSTOM_GROUP:
			return {
				...state,
				customGroup: action.payload.group,
			};

		case actions.SET_SEARCH_GROUP:
			return {
				...state,
				storedSearch: [...state.storedSearch, action.payload.group.userId],
			};

		case actions.SET_ALL_GROUPS:
			let groups = action.payload.groups;

			if (groups == null) return { ...state };

			const selectedGroups = groups.filter(group => (group.owners != null && group.owners.some((owner) => owner.selected)) || (group.members != null && group.members.some((member) => member.selected))).map(group => group);
			const selectedUsers = [
				...new Set(
					groups.flatMap(group => [
						...(Array.isArray(group.members) ? group.members.filter(member => member.selected) : []),
						...(Array.isArray(group.owners) ? group.owners.filter(owner => owner.selected) : [])
					])
				)
			];

			const hasChanges = selectedUsersChanged(state.selectedUsers, selectedUsers) || selectedGroupsChanged(state.selectedGroups, selectedGroups);

			if (hasChanges) {
				return {
					...state,
					groups: action.payload.groups,
					selectedUsers: selectedUsers,
					selectedGroups: selectedGroups,
				};
			}

			return {
				...state,
				groups: action.payload.groups,
			};

		case actions.REMOVE_ALL_USER:
			newUserFilter = [...action.payload.removed];
			if (action.payload.data?.students?.length) {
				return {
					...state,
					selectedGroups: { ...state.selectedGroups, [action?.payload?.data?.id]: false },
					userFilter: newUserFilter,
				};
			}

			return {
				...state,
				selectedGroups: { ...state.selectedGroups, [action?.payload?.data?.id]: false },
				userFilter: newUserFilter,
			};

		case actions.CHANGE_SELECTED_PEOPLE:
			newUserFilter = state.userFilter
				.filter((x) => x.id !== action.payload.selectedUser.id)
				.concat(action.payload.selectedUser);
			return {
				...state,
				selectedGroups: { ...state.selectedGroups, [action?.payload?.selectedUser?.id]: true },
				userFilter: newUserFilter,
			};

		case actions.CHANGE_SELECTED_OWNER:
			newUserFilter = state.userFilter
				.filter((x) => x.id !== action.payload.selectedUser.id)
				.concat(action.payload.selectedUser);
			return {
				...state,
				selectedGroups: { ...state.selectedGroups, [action?.payload?.selectedUser?.id]: true },
				userFilter: newUserFilter,
			};

		case actions.REMOVE_SELECTED_PEOPLE:
			if (
				action.payload.selectedUser.students.length === 0 &&
				action.payload.selectedUser.owners.length === 0
			) {
				newUserFilter = state.userFilter.filter((x) => x.id !== action.payload.selectedUser.id);
				return {
					...state,
					selectedGroups: { ...state.selectedGroups, [action.payload.selectedUser.id]: false },
					userFilter: newUserFilter,
				};
			}

			newUserFilter = state.userFilter
				.filter((x) => x.id !== action.payload.selectedUser.id)
				.concat(action.payload.selectedUser);
			return {
				...state,
				selectedGroups: { ...state.selectedGroups, [action.payload.selectedUser.id]: true },
				userFilter: newUserFilter,
			};

		case actions.REMOVE_SELECTED_OWNER:
			if (
				action.payload.selectedUser.students.length === 0 &&
				action.payload.selectedUser.owners.length === 0
			) {
				newUserFilter = state.userFilter.filter((x) => x.id !== action.payload.selectedUser.id);
				return {
					...state,
					selectedGroups: { ...state.selectedGroups, [action.payload.selectedUser.id]: false },
					userFilter: newUserFilter,
				};
			}

			newUserFilter = state.userFilter
				.filter((x) => x.id !== action.payload.selectedUser.id)
				.concat(action.payload.selectedUser);
			return {
				...state,
				selectedGroups: { ...state.selectedGroups, [action.payload.selectedUser.id]: true },
				userFilter: newUserFilter,
			};

		case actions.REMOVE_ALL:
			return {
				...state,
				userFilter: [],
				selectedGroups: {},
			};

		// Clear everything, used for when changing school
		case actions.CLEAR_ALL:
			return {
				...state,
				userFilter: [],
				selectedGroups: {},
				customGroup: [],
				storedSearch: [],
				advancedCalendarActive: false,
			};

		default:
			return state;
	}
}
